import { Box, UnstyledButton } from '@mantine/core';
import { modals } from '@mantine/modals';

import { RelatedResource, RelatedResourceStatus } from '@e-origin/shared';

import { notSentIcon, rejectedIcon, releasedIcon } from '@assets';
import { IdentificationDetails } from './IdentificationDetails';
import classes from './IdentificationStatusIcon.module.css';

interface IdentificationStatusIconProps {
  rowData: RelatedResource;
}

export const IdentificationStatusIcon: React.FC<IdentificationStatusIconProps> = ({ rowData }) => {
  const openErrorDetails = () => {
    modals.open({
      title: 'Errors',
      children: <IdentificationDetails list={rowData.errorsStack || []} onHide={modals.closeAll} />,
    });
  };

  const statusIconMapper = new Map([
    [
      RelatedResourceStatus.NEW,
      <Box className={classes.statusWrapper} key={0}>
        <img src={notSentIcon} />
        <span>No document provided</span>
      </Box>,
    ],
    [
      RelatedResourceStatus.EMPTY,
      <Box className={classes.statusWrapper} key={1}>
        <img src={notSentIcon} />
        <span>No document provided</span>
      </Box>,
    ],
    [
      RelatedResourceStatus.NOK,
      <Box className={classes.statusWrapper} key={2}>
        <img src={rejectedIcon} />
        <UnstyledButton
          className={classes.viewErrorsButton}
          onClick={() => {
            openErrorDetails();
          }}
        >
          View Errors
        </UnstyledButton>
      </Box>,
    ],
    [
      RelatedResourceStatus.OK,
      <Box className={classes.statusWrapper} key={3}>
        <img src={releasedIcon} />
        <span>Check OCR ok</span>
      </Box>,
    ],
  ]);

  return <>{statusIconMapper.get(rowData.status)}</>;
};
